// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const pageType = getCurrentPage(props.getState()).type;
    const isCheckoutPages = pageType === "CheckoutShippingPage" ||
        pageType === "CheckoutReviewAndSubmitPage" ||
        pageType === "CartPage" ||
        pageType === "OnePageCheckoutPage" ||
        pageType === "RfqRequestQuotePage" ||
        pageType === "OrderConfirmationPage";

    if(isCheckoutPages) {
        const expands = (props.apiParameter.expand || []).concat([`${(new Date()).getTime()}`] as any);
        props.apiParameter.expand = [...new Set(expands)] as typeof props.apiParameter.expand;
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);